var React = require('react');

function Alarm (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#737680","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M19 12.482V7.698c0-1.777-.738-3.48-2.05-4.736C15.637 1.706 13.857 1 12 1c-1.857 0-3.637.706-4.95 1.962C5.737 4.218 5 5.922 5 7.697v4.785c-.03 2.363-.72 4.675-2 6.697h18c-1.28-2.022-1.97-4.334-2-6.697z","key":0}),React.createElement("path",{"stroke":"#737680","d":"M10.55 22.06c-.196-.132-.37-.29-.517-.467h3.933c-.146.177-.32.335-.517.468-.422.285-.928.439-1.45.439-.52 0-1.027-.154-1.449-.44z","key":1})]);
}

Alarm.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = Alarm;

Alarm.default = Alarm;
